// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__18rNC","amount":"Amount_amount__5UXt3","tip":"Amount_tip__Fny8B","tipHeader":"Amount_tipHeader__1pIBt","tipsWrap":"Amount_tipsWrap__dGHWv"};